import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Hero from './components/Hero/Hero';
import Nav from './components/Nav/Nav';
import Video from './components/Video/Video';
import Story from './components/Story/Story';
import { Element } from 'react-scroll';
import './assets/sass/App.scss';
import Crisis from './components/widgets/Crisis';
import sal from './assets/img/sal.png';

const stories = [
  {
    title: 'Dignity Delivered',
    location: 'Detroit, Michigan',
    subTitle: 'Bed & Bread Program',
    text: `Like so much of America, Detroit has its share of economically depressed areas, making access to quality food and shelter more difficult. The Eastern Michigan Division of The Salvation Army’s Bed & Bread trucks make sure that community members can get a meal every day.`,
    widgetType: 0,
    tag: 'Food Scarcity',
    slug: 'food-scarcity',
    url: ''
  },
  {
    title: 'THE GIFT OF HOPE',
    location: 'Buffalo, New York',
    subTitle: 'Pathway of Hope',
    text: `For the millions of Americans who grew up in poverty, finding a way out can be incredibly difficult. The Salvation Army’s Pathway of Hope program provides mentorship, coaching, and economic assistance to help its clients meet concrete goals and achieve stability and find hope for the future.`,
    widgetType: 1,
    tag: 'Generational Poverty',
    slug: 'generational-poverty',
    url: ''
  },
  {
    title: 'THE DIGNITY OF A DREAM',
    location: 'Los Angeles, California',
    subTitle: 'The way in',
    text: `Over 8,000 youth sleep on the streets of Los Angeles each night. The Salvation Army started The Way In to make sure those youth have a place to sleep—and a way out of street life, to the bright future they deserve.`,
    widgetType: 2,
    tag: 'Youth Homelessness',
    slug: 'youth-homelessness',
    url: ''
  }
];

function App() {
  return (
    <div className="app">
      <Header />
      <Nav />
      <Hero />
      <section className="spaced">
        <div className="text-block">
          <h4>The Salvation Army was founded on the belief that everyone deserves dignity.</h4>
          <p>
            Dignity does not depend on your class, race, or sexual identity. It’s not tied to
            sobriety or housing, faith, profession. It does not speak a particular language or
            necessitate an immigration status. In fact, it cannot be earned.
          </p>
          <p>Dignity asserts that your worth as a human being is absolute.</p>
          <p>And without dignity, it’s impossible to thrive.</p>
          <p>
            But in 2021, as a pandemic continues to bear down on America, it’s increasingly hard for
            millions of people to assert their human dignity—or have it acknowledged by the broader
            culture.
          </p>
        </div>
      </section>
      <section className="grey">
        <div className="section-split-block">
          <div>
            <h4>A Crisis Unfolding Before Us</h4>
            <p>
              Americans are continuing to make excruciating decisions as they face the ongoing
              economic impacts of the pandemic. On any given night in 2020, 580,000 Americans
              experienced homelessness, and 37.2 million Americans were living in poverty. They’re
              having to choose between keeping the lights on and putting food on the tables.
            </p>
          </div>
          <div>
            <Crisis />
          </div>
        </div>
      </section>

      <section className="blue">
        <div className="section-split-block section-split-block--image">
          <div>
            <p className="section-tag">Host</p>
            <h3 className="photo-slide-name">Krista Tippett</h3>
            <p className="photo-slide-text">
              Krista Tippett is an American journalist, author, and entrepreneur. She created and
              hosts the public radio program and podcast On Being. In 2014, Tippett was awarded the
              National Humanities Medal.
            </p>
          </div>
          <div>
            <Video url={'https://player.vimeo.com/video/651358211'} />
          </div>
        </div>
      </section>
      {stories &&
        stories.map((story, i) => {
          return (
            <Element name={story.slug} className="element">
              <Story index={i} key={story.title} story={story} />
            </Element>
          );
        })}

      <div className="story story--alone">
        <div className="h-line"></div>
      </div>
      <section className="centered">
        <div>
          <img src={sal} alt="salvation army logo" className="cta-logo" />
          <a
            target="_blank"
            rel="noreferrer"
            href="https://give.salvationarmyusa.org/give/164006/?gclid=Cj0KCQiAsqOMBhDFARIsAFBTN3cA0t5j3GAzsfW-aCDSXl5EcwwhZDe-AqRQ75CbfE-L_l0ASn0Ib-kaAmFhEALw_wcB#!/donation/checkout?utm_source=google_lerma&utm_medium=cpc&utm_term=general_brand&utm_content=text&utm_campaign=edonation_eastern_brand&pid=cpc:edonation_eastern_brand::google_lerma:::::eastern_eastern:general_brand:evergreen"
            className="donate-now donate-now--red"
          >
            Help hope march on
          </a>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default App;
